import { proxyClientOptions, RestfulClient, Session } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { ShortInterestParams, ShortInterestResponse } from '../../entities';
import { QuotesEnvironment } from '../../environment';
import { quotesInterestRoutes } from './routes';
import { QuotesInterestTransport } from './types';

export class QuotesInterestRestful extends RestfulClient implements QuotesInterestTransport {
  constructor(session: Session) {
    const env = session.getEnvironment(QuotesEnvironment);
    super(env.shortInterestUrl, session, { 'x-device-key': true }, proxyClientOptions());
  }

  getShortInterests = async (params: ShortInterestParams): SafePromise<ShortInterestResponse> => {
    const env = this.session.getEnvironment(QuotesEnvironment);
    const path = this.routePath(quotesInterestRoutes.shortInterest);
    const url = this.URL(
      path,
      this.withUpstreamCredentials(
        {
          asOf: params.asOf,
          finraReport: true,
          from: params.dateFrom,
          symbols: params.symbols ? params.symbols.join(',') : undefined,
          to: params.dateTo,
        },
        { apikey: env.shortInterestKey },
      ),
    );
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
